/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import AnnotationsRow from './AnnotationsRow';

type AnnotationsRowsProps = {
  children: any,
  router: Object
}

let AnnotationsRows = ({
  children, router
}: AnnotationsRowsProps): React.Element => (
  TBody({
    children: children.map(cas => (
        <AnnotationsRow key={cas.id} router={router}>{cas}</AnnotationsRow>
      ))
  })
);

export default AnnotationsRows;
